<ng-container *transloco="let t; prefix: 'payment.wizard.stepThree'">
    <!-- Header -->
    <div class="flex flex-col w-full gap-2 items-center justify-center">
        <h2 class="rfs:text-[40px] text-center font-semibold text-black">
            {{t('header')}}
        </h2>
        <p class="rfs:text-xl text-center font-light text-tone-09">
            {{t('infoText')}}
        </p>
    </div>
    <!-- END OF Header -->

    <!-- Select entry Button group by category -->
    <div class="flex justify-center w-full max-w-[800px]">
        <app-tab-pill-group-button class="flex-1" [items]="tabPillGroupButtons"
            [alwaysShowPill]="true"
            (itemSelected)="handleButtonGroupItemSelected($event)" />
    </div>
    <!-- END OF Select entry Button group by category -->

    <!-- Input value based on the selected type -->
    @if (this.caseItem === 'receipt') {

    }
    <!-- END OF Input value based on the selected type -->
</ng-container>